import { render, staticRenderFns } from "./PagePop.vue?vue&type=template&id=eb907984&scoped=true"
import script from "./PagePop.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagePop.vue?vue&type=style&index=0&id=eb907984&prod&lang=css"
import style1 from "./PagePop.vue?vue&type=style&index=1&id=eb907984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb907984",
  null
  
)

export default component.exports